export const heroSlides = [
  {
    id: "slide-1",
    title: "星环彼岸 开播特辑",
    subtitle: "本季最高规格原创科幻，探索船驶向未知的彼岸信号",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20style%20wide%20background%20of%20a%20glowing%20cyberpunk%20city%20skyline%20at%20sunset%20with%20warm%20orange%20sky%20and%20deep%20navy%20silhouettes%2C%20no%20text%2C%20abstract%20atmospheric%20illustration%2C%20cinematic%20color%20grading%2C%20clean%20composition&width=1600&height=900&seq=hero-slide-1&orientation=landscape",
    link: "/updates/star-ring-beyond",
    tag: "热门更新",
    tagEn: "FEATURED"
  },
  {
    id: "slide-2",
    title: "秋季新番前瞻",
    subtitle: "12 部值得期待的动画，一次看清新番格局",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20style%20wide%20background%20of%20a%20fantasy%20floating%20island%20kingdom%20above%20golden%20clouds%20at%20dawn%2C%20warm%20orange%20light%2C%20deep%20navy%20shadows%2C%20abstract%20atmospheric%20illustration%2C%20no%20text%2C%20cinematic%20color%20grading&width=1600&height=900&seq=hero-slide-2&orientation=landscape",
    link: "/news/new-anime-season-preview-2026",
    tag: "专题活动",
    tagEn: "SPECIAL"
  },
  {
    id: "slide-3",
    title: "精选角色档案上线",
    subtitle: "首字母索引快速定位你喜欢的角色，了解他们的故事",
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20style%20wide%20background%20of%20a%20school%20rooftop%20with%20cherry%20blossoms%20flying%20at%20golden%20hour%2C%20warm%20orange%20sunlight%2C%20deep%20navy%20sky%2C%20abstract%20atmospheric%20illustration%2C%20no%20text%2C%20cinematic%20color%20grading&width=1600&height=900&seq=hero-slide-3&orientation=landscape",
    link: "/characters",
    tag: "角色档案",
    tagEn: "CHARACTERS"
  }
];

export const featuredCollections = [
  {
    id: "collection-autumn-2026",
    title: "2026 秋季新番全景",
    desc: "从制作规格到题材分布，一页读懂本季新番格局。",
    count: 12,
    link: "/news"
  },
  {
    id: "collection-anime-craft",
    title: "动画幕后科普合集",
    desc: "作画、分镜、声音设计，看懂一集动画背后的工序。",
    count: 8,
    link: "/news"
  },
  {
    id: "collection-character-files",
    title: "人气角色档案",
    desc: "精选本季讨论度最高的角色，附作品与关联资讯。",
    count: 24,
    link: "/characters"
  },
  {
    id: "collection-weekly-updates",
    title: "每周更新速递",
    desc: "按星期整理播出表，再也不会错过喜欢的更新。",
    count: 36,
    link: "/updates"
  }
];